const normalizeText = (value = '') => String(value || '').trim();

const escapeRegExp = (value = '') => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const getUserDisplayName = (userName, fullName) => {
  const code = normalizeText(userName);
  const name = normalizeText(fullName);

  if (!code || !name) {
    return name;
  }

  return name.replace(new RegExp(`^${escapeRegExp(code)}\\s*-\\s*`, 'i'), '').trim();
};

export const formatUserLabel = (userName, fullName) => {
  const code = normalizeText(userName);
  const name = getUserDisplayName(code, fullName);

  if (code && name) {
    return `${code} - ${name}`;
  }

  return code || name;
};
